import getEnvironDomain from 'utils/getEnvironDomain';

export const verificationPageLink = `//${getEnvironDomain()}/verification`;
